import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { DocManiaLogo, DocManiaLogoImage } from './DocManiaLogo';
import { CreditBadge } from './CreditBadge';
import { ArrowLeft } from 'lucide-react';

export function PublicToolHeader({ backTo = '/' }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <header className="border-b border-border bg-white safe-area-top">
      <div className="max-w-5xl mx-auto flex items-center justify-between h-14 sm:h-16 px-4 sm:px-6">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            className="h-10 w-10 min-w-[40px]"
            onClick={() => navigate(backTo)}
            data-testid="tool-header-back"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <button
            type="button"
            className="flex items-center gap-2"
            onClick={() => navigate('/')}
            aria-label="DocMania home"
          >
            <DocManiaLogoImage size={28} />
            <DocManiaLogo size="small" />
          </button>
        </div>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <CreditBadge balance={user.credit_balance} />
              <Button variant="outline" size="sm" onClick={() => navigate('/dashboard')}>
                Dashboard
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate('/login')}>
                Sign In
              </Button>
              <Button size="sm" className="glow-button" onClick={() => navigate('/signup')}>
                Get Started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
